// extracted by mini-css-extract-plugin
module.exports = {"container":"FrameQuickNav_container__1vSdC","quickNavBtn":"FrameQuickNav_quickNavBtn__2x03-"};